/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Card, Checkbox, Divider, Input, Pagination, Tabs, Tag } from "antd";
import { LoadingComponent } from "@/components/ui/LoadingComponent";
import { JobCard } from "@/pages/industrialPark/components/JobCard";
import { CompanyCard } from "@/pages/industrialPark/components/CompanyCard";
import IndustrialService from '@/services/IndustrialService'
import config from "@/config";
import JobService from "@/services/JobService";
import CompanyService from "@/services/CompanyService";

const DetailIndustry = () => {
    const [query, setQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const [industry, setIndustry] = useState({});
    const [jobs, setJobs] = useState([]);
    const [companies, setCompanies] = useState([]);

    const { id } = useParams();

    useEffect(() => {
        setLoading(true);
        IndustrialService.getId(id).then(res => {
            setIndustry(res.Data)
            setLoading(false);
        })
        JobService.getQuery({ kcnId: id }).then(res => setJobs(res))
        CompanyService.getCompany({ kcnId: id }).then(res => setCompanies(res))
    }, [id]);

    const ITEM_PER_PAGE = 6;
    const [current, setCurrent] = useState(1);

    const pageJob = jobs.slice((current - 1) * ITEM_PER_PAGE, current * ITEM_PER_PAGE);
    const pageCompany = companies.slice((current - 1) * ITEM_PER_PAGE, current * ITEM_PER_PAGE);

    const onChange = (page) => {
        setCurrent(page);
    }

    const handleTabChange = (key) => {
        setCurrent(1)
    }

    const handleInputChange = (e) => {
        setQuery({ ...query, searchText: e.target.value });
    }
    const handleCheckboxChange = (type, value) => {
        setQuery({
            ...query,
            [type]: value,
        });
    }
    if (loading) {
        return <LoadingComponent />
    }

    return (
        <div className={"bg-gray-100"}>
            <div className="container mx-auto py-10 px-4 sm:px-2 md:px-4">
                {/* Banner Section */}
                <Card className="rounded-xl mb-10">
                    <div className="container mx-auto">
                        <img
                            src={config.ImageConfig.getBanner(industry.Banner)}
                            alt="banner"
                            className="w-full max-h-56 rounded-t-xl object-cover"
                        />
                        <div className="lg:ms-8 block -mt-16">
                            <div className={"flex flex-col lg:flex-row"}>
                                <div className={"avatar items-center justify-center flex flex-col"}>
                                    <img
                                        src={config.ImageConfig.getBanner(industry.Logo)}
                                        className="border border-gray-5 lg:-mt-30 mt-25 mx-32 lg:mx-auto lg:h-48 lg:w-48 h-32 w-32 shadow-xl aspect-square rounded-full"
                                    />
                                </div>
                                <div className="flex  items-center lg:mt-24 lg:ml-20 justify-center">
                                    <div className={"grid grid-cols-1"}>
                                        <h2 className="text-2xl font-bold">{industry?.NameKcn}</h2>
                                        <div className="text-gray-500 text-lg"><i
                                            className="fa-solid fa-location-dot me-2 "></i>{industry?.NameTinh}
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
                                            <div className={"flex items-center gap-2"}>
                                                <Tag color="blue">Phía {industry?.NameKhuVuc}</Tag>
                                                <Tag color="orange">Có {industry?.JobCount} việc làm</Tag>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>

                {/* Main Content */}
                <Card className={"col-span-2"}>
                    <Tabs onChange={handleTabChange} centered defaultActiveKey="1" items={[
                        {
                            key: '1',
                            label: 'Các việc làm trong khu công nghiệp',
                            children: (
                                <>
                                    <h2 className="text-center font-bold text-xl">
                                        Danh sách công việc nổi bật ({jobs.length})
                                    </h2>
                                    <Divider style={{ borderColor: '#7cb305' }} />
                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                                        {pageJob.map((job, index) => (
                                            <JobCard key={index} job={job} />
                                        ))}
                                        <div className="col-span-full flex justify-center">
                                            {jobs.length > ITEM_PER_PAGE && (
                                                <Pagination
                                                    current={current}
                                                    onChange={onChange}
                                                    total={jobs.length}
                                                    pageSize={ITEM_PER_PAGE}
                                                    showSizeChanger={false}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </>
                            ),
                        },
                        {
                            key: '2',
                            label: 'Các công ty trong khu công nghiệp',
                            children: (
                                <>
                                    <h2 className="text-center font-bold text-xl">
                                        Danh sách công ty nổi bật ({companies.length})
                                    </h2>
                                    <Divider style={{ borderColor: '#7cb305' }} />
                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
                                        {pageCompany.map((company, index) => (
                                            <CompanyCard key={index} company={company} />
                                        ))}
                                        <div className="col-span-full flex justify-center">
                                            {companies.length > ITEM_PER_PAGE && (
                                                <Pagination
                                                    current={current}
                                                    onChange={onChange}
                                                    total={companies.length}
                                                    pageSize={ITEM_PER_PAGE}
                                                    showSizeChanger={false}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </>
                            ),
                        },
                    ]} />;
                </Card>
                {/* <Card className={"max-h-full"}>
                        <h2 className={"font-bold text-xl"}>Tìm kiếm theo bộ lọc</h2>
                        <Divider style={{ borderColor: '#7cb305' }} />
                        <div className={"grid grid-cols-1 space-y-6"}>
                            <Input
                                allowClear
                                rootClassName={"rounded-3xl p-3"}
                                placeholder="Tìm kiếm công ty/công việc"
                                value={query}
                                onChange={handleInputChange}
                            />
                            <Card
                                className="container mx-auto rounded-3xl border border-green-700 mb-4 bg-green-200">
                                <label className="text-lg font-medium text-gray-800">Ngành nghề</label>
                                <div className="grid grid-cols-1 gap-2">
                                    <Checkbox.Group
                                        // options={Data.Jobs}
                                        value={query.job}
                                        onChange={(value) => {
                                            handleCheckboxChange("job", value);
                                        }}
                                        className="grid grid-cols-2 items-center" // Thêm class để căn chỉnh
                                    />
                                </div>
                            </Card>
                            <Card
                                className="container mx-auto rounded-3xl border border-green-700 bg-green-200">
                                <label className="text-lg font-medium text-gray-800">Cấp bậc</label>
                                <div className="grid grid-cols-1">
                                    <Checkbox.Group
                                        // options={Data.Rank}
                                        value={query.rank}
                                        onChange={(value) => {
                                            handleCheckboxChange("rank", value);
                                        }}
                                        className="grid grid-cols-2 items-center" // Thêm class để căn chỉnh
                                    />
                                </div>
                            </Card>
                        </div>
                        <div className={"flex flex-1 mt-24 justify-center"}>
                            <button
                                className={"bg-[#17B1B1] hover:bg-[#108787] text-white p-2 rounded-lg w-1/2 font-semibold"}>
                                Tìm kiếm
                            </button>
                        </div>
                    </Card> */}
            </div>
        </div>
    );
}

export default DetailIndustry;